import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { DashboardPage } from '../pages/DashboardPage';
import { LandingPage } from '../components/LandingPage';
import { ListingTool } from '../pages/tools/ListingTool';
import { MockupTool } from '../pages/tools/MockupTool';
import { EnhancerTool } from '../pages/tools/EnhancerTool';
import { HistoryTool } from '../pages/tools/HistoryTool';
import { GenericTool } from '../pages/tools/GenericTool';
import { Profile } from '../components/Profile';
import { Admin } from '../components/Admin';
import { PricingTool } from '../pages/tools/PricingTool';
import { ADMIN_EMAILS } from '../constants';

export const AppRoutes: React.FC = () => {
  const { user, loading, login } = useAuth();
  
  const isAdmin = user && (
    (user.email && ADMIN_EMAILS.includes(user.email)) || 
    user.email === 'admin@listingstudio.co'
  );

  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center bg-slate-50">
        <Loader2 className="animate-spin text-primary-600 mx-auto mb-4" size={40} />
      </div>
    );
  }

  const handleLogin = async () => {
      try {
          await login();
      } catch (e) {
          console.error(e);
      }
  };

  return (
    <Routes>
       <Route path="/" element={
          user ? <Navigate to="/dashboard/listing" /> : <LandingPage onLogin={handleLogin} user={user} isLoading={loading} />
       } />
       
       <Route path="/dashboard" element={user ? <DashboardPage /> : <Navigate to="/" />}>
          <Route path="listing" element={<ListingTool />} />
          <Route path="redesign" element={<GenericTool toolId="redesign" />} />
          <Route path="mockup" element={<MockupTool />} />
          <Route path="enhance" element={<EnhancerTool />} />
          <Route path="clone" element={<GenericTool toolId="clone" />} />
          <Route path="embroidery" element={<GenericTool toolId="embroidery" />} />
          <Route path="removebg" element={<GenericTool toolId="removebg" />} />
          <Route path="upscale" element={<GenericTool toolId="upscale" />} />
          <Route path="history" element={<HistoryTool />} />
          <Route path="profile" element={<Profile user={user!} />} />
          <Route path="pricing" element={<PricingTool />} />
          <Route path="admin" element={isAdmin ? <Admin /> : <Navigate to="/dashboard/listing" />} />
          <Route index element={<Navigate to="listing" />} />
       </Route>

       {/* Fallback */}
       <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
};
